const PLACEHOLDER = /\$([A-Za-z][A-Za-z0-9_]*)\$/g;

export const normalizeVariableList = (value) => {
  if (typeof value === "string") {
    try {
      return normalizeVariableList(JSON.parse(value));
    } catch (error) {
      return [];
    }
  }
  if (!Array.isArray(value)) return [];
  return value.filter((item) => typeof item === "string");
};

export const extractVariableNames = (text) => {
  if (!text) return [];
  const found = [];
  const seen = new Set();
  const pattern = new RegExp(PLACEHOLDER);
  let match;

  while ((match = pattern.exec(text))) {
    const name = match[1];
    const key = name.toLowerCase();
    if (!seen.has(key)) {
      seen.add(key);
      found.push(name);
    }
  }

  return found;
};

export const placeholdersMissingFromList = (texts, variables) => {
  const allowed = new Set(
    (variables || []).map((name) => String(name).toLowerCase())
  );
  const missing = [];
  const seen = new Set();

  texts.forEach((text) => {
    extractVariableNames(text).forEach((name) => {
      const key = name.toLowerCase();
      if (!allowed.has(key) && !seen.has(key)) {
        seen.add(key);
        missing.push(name);
      }
    });
  });

  return missing;
};

export const renderSmsTemplate = (text, variables) => {
  if (typeof text !== "string") return "";
  let output = text;

  Object.keys(variables || {}).forEach((key) => {
    const value = variables[key];
    if (value === undefined || value === null || value === "") return;
    output = output.replace(
      new RegExp("\\$" + key + "\\$", "gi"),
      String(value)
    );
  });

  return output;
};
